import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';

import { IVendor } from "../../../types/vendor";

import { useUserContext } from "../../../contexts/userContext";

import { VendorService } from "../../../services/vendorService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import VendorDetailsForm from '../../forms/vendorDetailsForm';
import VendorContactForm from '../../forms/vendorContactForm';
import VendorAddressesForm from '../../forms/vendorAddressesForm';
import VendorCustomersForm from '../../forms/vendorCustomersForm';
import DocumentTable from '../../tables/documentTable';
import DocumentViewer from '../../documentViewer';
import VendorMaterialsForm from '../../forms/vendorMaterialsForm';
import { Icons } from '../../icons';
import { useListContext } from '../../../contexts/listContext';
import Spinner from '../../spinner';

const VendorEdit = () => {
	const userContext = useUserContext();
	const listContext = useListContext();
	let { id } = useParams();
	const [vendor, setVendor] = useState<IVendor>();
	const [activeTab, setActiveTab] = useState("details");
	const [isLoadingVendor, setIsLoadingVendor] = useState(true);
	const [isInitialLoad, setIsInitialLoad] = useState(true);
	const [selectedDocumentId, setSelectedDocumentId] = useState<string>();
	const [entityTypeId, setEntityTypeId] = useState("");


	useEffect(() => {
		let et = listContext.entityTypes.filter((item) => { return item.name.toLowerCase() == "vendor" })

		if (et.length > 0) {
			setEntityTypeId(et[0].value);
		}
	}, [id])

	const getVendor = async () => {
		if (id) {
			VendorService.getVendor(id)
				.then((response) => {
					console.log('VendorService.getVendor: SUCCESS', response);
					setVendor(VendorService.mapVendor(response.data));
				})
				.catch((error) => {
					console.log('VendorService.getVendor: ERROR', error);
				})
				.finally(() => {
					setIsLoadingVendor(false);
					setIsInitialLoad(false);
				});
		}
	}

	const handleDocumentDeleted = (id: number) => {
		vendor.documents = vendor.documents.filter(doc => doc.id !== id);
		setVendor({ ...vendor });
	}

	useEffect(() => {
		getVendor();
	}, [id])

	return (
		<div className="hwi-vendor-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageVendors}>
					<>
						<Spinner dependency={isLoadingVendor && isInitialLoad} text='Loading vendor...'>
							<section className="management-page-header">
								<div className="title">
									<NavLink to="/vendor">
										<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
									</NavLink>
									{vendor?.details?.name}
								</div>
								<div className="tabs">
									<div className={activeTab == "details" ? "tab active" : "tab"} onClick={() => setActiveTab("details")}>Details</div>
									<div className={activeTab == "contact" ? "tab active" : "tab"} onClick={() => setActiveTab("contact")}>Contact</div>
									<div className={activeTab == "addresses" ? "tab active" : "tab"} onClick={() => setActiveTab("addresses")}>Addresses</div>
									<div className={activeTab == "customers" ? "tab active" : "tab"} onClick={() => setActiveTab("customers")}>Customers</div>
									<div className={activeTab == "materials" ? "tab active" : "tab"} onClick={() => setActiveTab("materials")}>Materials</div>
									<div className={activeTab == "documents" ? "tab active" : "tab"} onClick={() => setActiveTab("documents")}>Documents</div>
								</div>
							</section>
							<Spinner dependency={isLoadingVendor} text='Loading vendor...'>
								{vendor?.details && activeTab == "details" &&
									<section>
										<VendorDetailsForm id={id} action="edit" customers={vendor.customers} details={vendor.details} reloadData={getVendor}></VendorDetailsForm>
									</section>
								}
								{activeTab == "contact" &&
									<section>
										<VendorContactForm id={id} contact={vendor.contact}></VendorContactForm>
									</section>
								}

								{activeTab == "addresses" &&
									<section>
										<VendorAddressesForm id={id} mailingAddress={vendor.mailingAddress} shippingAddress={vendor.physicalAddress} reloadData={getVendor}></VendorAddressesForm>
									</section>
								}

								{activeTab == "customers" &&
									<section>
										<VendorCustomersForm id={id} customers={vendor.customers}></VendorCustomersForm>
									</section>
								}

								{activeTab == "materials" &&
									<section>
										<VendorMaterialsForm id={id} data={vendor.materials}></VendorMaterialsForm>
									</section>
								}

								{activeTab == "documents" &&
									<div className="hwi-document-list">
										<DocumentTable
											data={vendor?.documents}
											entityId={id}
											entityTypeId={entityTypeId}
											hideAddDocumentsLink={false}
											hideDeleteDocumentsLink={false}
											onRequestListRefresh={getVendor}
											onViewDocument={(id) => { setSelectedDocumentId(id?.toString()) }}
											onDocumentDeleted={(id) => { handleDocumentDeleted(id) }}
										></DocumentTable>
										{selectedDocumentId &&
											<DocumentViewer documentId={+selectedDocumentId}></DocumentViewer>
										}
									</div>
								}
							</Spinner>
							{/* <Json data={vendor}></Json> */}
						</Spinner>
					</>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default VendorEdit;